import request from "./request";
export const http = {
  // 繁星KA-门店商家弹窗列表
  getKaBindCompanyList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/getKaBindCompanyList",
      data: params,
    });
  },
  // 繁星KA-添加
  saveKaBindCmccCompany(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/saveKaBindCmccCompany",
      data: params,
    });
  },
  // 繁星KA-列表
  getKaBindCmccCompanyList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/getKaBindCmccCompanyList",
      data: params,
    });
  },
  // 繁星KA-复制订单启用
  updateCompanyIsOpenPc(params) {
    return request({
      method: "GET",
      url: "/platform/pc/kaBindCmcc/updateCompanyIsOpenPc",
      params: params,
    });
  },
  // 导入绑定省移动店员（仅支持.xls及.xlsx格式）
  importAssignMachine(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/importAssignMachine",
      data: params,
    });
  },
  // 门店商家下拉列表
  getCompanySelectList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/kaBindCmcc/getCompanySelectList",
      params,
    });
  },
  // 店员-列表
  geStaffList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/geStaffList",
      data: params,
    });
  },
  // 导出-繁星店员列表
  excelStaffList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/excel-staff",
      data: params,
      responseType: "blob",
    });
  },
  // 店员-省移动商列表
  getCmccStaffList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/getCmccStaffList",
      data: params,
    });
  },
  // 店员-绑定
  staffBind(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/staff-bind",
      data: params,
    });
  },
  // 店员-复制订单启用
  updateStaffIsOpenPc(params) {
    return request({
      method: "GET",
      url: "/platform/pc/kaBindCmcc/updateStaffIsOpenPc",
      params,
    });
  },
  // 店员-取消绑定
  staffUnbind(params) {
    return request({
      method: "POST",
      url: "/platform/pc/kaBindCmcc/staff-unbind",
      data: params,
    });
  },
  // 店员-绑定信息
  staffBindInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/kaBindCmcc/staff-bind-info",
      params,
    });
  },
};
